import React, { useEffect, useRef, useState } from "react";
import { Field } from "redux-form";
import { required } from "redux-form-validators";

import { getIcon } from "../../../../helpers/icons";
import { planList } from "../../../../helpers/list";
import { scrollToTop } from "../../../../helpers/animation";
import { Button, Input } from "../../../../components/Field";
import Text from "../../../../components/Text";
import Link from "../../../../components/Link";
import Title from "../../../../components/Title";
import AsyncGet from "../../../../components/AsyncGet";
import AsyncForm from "../../../../components/AsyncForm";
import FormatPrice from "../../../../components/MemberForm/FormatPrice";

import style from "../style.module.css";

export default function ConfirmDetails(props) {

    const {
        nextStep,
        personalDetails,
        planType,
        planId = ""
    } = props;

    const [editField, setEditField] = useState(null);
    const [planData, setPlanData] = useState({});
    const formRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (formRef.current && !formRef.current.contains(event.target)) {
                setEditField(null);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [formRef]);

    return (
        <div className={style.confirmDetails}>
            <AsyncGet
                url={`/membership/membership-detail/${planId}`}
                permissionText={false}
                loadOnMount={true}
                onFetch={({ data }) => {
                    setPlanData(data);
                }}
                render={() => {
                    return (
                        <AsyncForm
                            id="step03"
                            url={`/account/reactive-confirmdetails`}
                            type="update"
                            permission="Reactive Confirmdetails"
                            showToastOnSuccess={false}
                            hasGetAction={false}
                            initialValues={
                                {
                                    email: personalDetails.email,
                                    first_name: personalDetails.first_name,
                                    surname: personalDetails.surname,
                                }
                            }
                            paramsData={{
                                plan_id: planId,
                            }}
                            onSave={({ data }) => {
                                nextStep(planType !== 3 && planType !== undefined ? 'Discounts' : 'Congratulations');
                                scrollToTop();
                            }}
                            render={({ fetching }) => {
                                return (
                                    <div className={style.form}>
                                        <div className={style.formRow}>
                                            <Text className="formTitle" text="PERSONAL DETAILS" />
                                        </div>
                                        <div className={style.listWrap}>
                                            <div className={`${style.listItem} ${style.dashed} ${style.promotionalCodeApplyedAmountDetails}`}>
                                                <div className={style.mainArea}>
                                                    <div className={style.planName}>
                                                        <Title tag="p">{planData.full_title}</Title>
                                                    </div>
                                                    <div className={style.promotionalDescription}>
                                                        <Title tag="p">
                                                            <span>{planData.full_title}</span>
                                                            <span>{planList()[planData.plan_type || '']}</span>
                                                            <span><FormatPrice planType={planData.plan_type} price={planData.price} /></span>
                                                        </Title>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={style.formRow}>
                                            {
                                                editField === "first_name" && (
                                                    <div className={style.dynamicFormRow} ref={formRef}>
                                                        <div className={`${style.prevValueRow} ${style.active}`}>
                                                            <Field
                                                                label="First Name"
                                                                placeholder="Enter your first name"
                                                                name="first_name"
                                                                component={Input}
                                                                validate={required()}
                                                            />
                                                        </div>
                                                    </div>
                                                )
                                            }
                                            {
                                                editField !== "first_name" && (
                                                    <div className={style.dynamicFormRow}>
                                                        <div className={`${style.prevValueRow} ${style.inActive}`}>
                                                            <Field
                                                                label="First Name"
                                                                placeholder="Enter your first name"
                                                                name="first_name"
                                                                disabled
                                                                component={Input}
                                                                validate={required()}
                                                            />
                                                            <Link
                                                                onClick={() => { setEditField('first_name') }}
                                                                className={style.editBtn}
                                                            >
                                                                <i className={getIcon("Pen")}></i>
                                                            </Link>
                                                        </div>
                                                    </div>
                                                )
                                            }
                                        </div>
                                        <div className={style.formRow}>
                                            {
                                                editField === "surname" && (
                                                    <div className={style.dynamicFormRow} ref={formRef}>
                                                        <div className={`${style.prevValueRow} ${style.active}`}>
                                                            <Field
                                                                label="Surname"
                                                                placeholder="Enter your surname"
                                                                name="surname"
                                                                component={Input}
                                                                validate={required()}
                                                            />
                                                        </div>
                                                    </div>
                                                )
                                            }
                                            {
                                                editField !== "surname" && (
                                                    <div className={style.dynamicFormRow}>
                                                        <div className={`${style.prevValueRow} ${style.inActive}`}>
                                                            <Field
                                                                label="Surname"
                                                                placeholder="Enter your surname"
                                                                name="surname"
                                                                disabled
                                                                component={Input}
                                                                validate={required()}
                                                            />
                                                            <Link
                                                                onClick={() => { setEditField('surname') }}
                                                                className={style.editBtn}
                                                            >
                                                                <i className={getIcon("Pen")}></i>
                                                            </Link>
                                                        </div>
                                                    </div>
                                                )
                                            }
                                        </div>
                                        <div className={style.formRow}>
                                            <Text className="formLabelZillaSlab" text="Email address" />
                                            <div className={style.dynamicFormRow}>
                                                <div className={style.prevValueRow}>
                                                    <Text className="size14" text={personalDetails.email} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className={`${style.formRow} ${style.formRowHide}`}>
                                            <Field
                                                name="email"
                                                component={Input}
                                                validate={required()}
                                                type="hidden"
                                            />
                                        </div>
                                        <div className={`${style.formRow} ${style.formSubmit}`}>
                                            <Button
                                                submit={true}
                                                fetching={fetching}
                                                label={planType !== 3 && planType !== undefined ? `PAYMENT` : `NEXT`}
                                            />
                                        </div>
                                    </div>
                                )
                            }}
                        />
                    )
                }}
            />
        </div>
    )
}